module.exports = __webpack_public_path__ + "img/147.d7fde447.jpg";